/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconRefreshFilled extends React.Component {
  render() {
    const iconClasses = classNames("icon refresh-filled", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M15.006,22.001 c-1.807,0-3.601-0.697-4.955-2.051c-1.332-1.331-2.042-3.111-2.04-4.95H6l3-3l3,3h-1.992c-0.001,1.314,0.507,2.585,1.457,3.536 c1.701,1.702,4.371,1.951,6.354,0.596l1.129,1.65C17.751,21.601,16.375,22.001,15.006,22.001z M21,18l-3-3h1.992 c0.001-1.314-0.507-2.585-1.457-3.536c-1.702-1.702-4.371-1.95-6.354-0.596l-1.129-1.65c2.775-1.899,6.516-1.548,8.896,0.832 c1.332,1.331,2.042,3.111,2.04,4.95H24L21,18z" />
      </svg>
    );
  }
}

IconRefreshFilled.defaultProps = {
  className: null
};

IconRefreshFilled.propTypes = {
  className: PropTypes.string
};

export default IconRefreshFilled;
